var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("dashboard-management", {
    attrs: {
      "application-id": _vm.applications.Provider,
      "change-post-status": _vm.api.changePostStatus,
      "get-all-posts": _vm.api.getAllPosts,
      "get-applications": _vm.api.getApplications,
      "get-document": _vm.api.getDocument,
      "get-guides": _vm.api.getGuides,
      "get-links": _vm.api.getLinks,
      "get-modules": _vm.api.getModules,
      "get-types": _vm.api.getTypes,
      "get-videos": _vm.api.getVideos,
      "mark-messages": _vm.api.markMessages,
      "update-participant-workshop-status":
        _vm.api.updateParticipantWorkshopStatus
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }